import { arrayToSimpleObj } from '../utils';

export const recordTimesOptions = [
  {
    text: '0-5h',
    value: '0-5',
  },
  {
    text: '5-10h',
    value: '5-10',
  },
  {
    text: '10-20h',
    value: '10-20',
  },
  {
    text: '20-50h',
    value: '20-50',
  },
  {
    text: '50-80h',
    value: '50-80',
  },
  {
    text: '80-100h',
    value: '80-100',
  },
  {
    text: '100h+',
    value: '100+',
  },
];

export const recordTimesMap = arrayToSimpleObj(recordTimesOptions);
